module.exports = __webpack_public_path__ + "media/v2/components/PromoPages/shared/PlayVideoButton/playIcon-ba64b0f95241615811d6f336ad866e19.svg";